// extracted by mini-css-extract-plugin
export default {"notice":"EuCofundingNotice_notice__mfCO3","logo":"EuCofundingNotice_logo__8MjUy","text":"EuCofundingNotice_text__mLh+4"};